<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>院系机构管理</p>
    </div>
    <div class="panel-content center_content">
      <div class="tab-wrap">
        <ul>
          <li
            @click="asdSwitch(2)"
            :class="{'on':onClick==2}"
          >学院管理</li>
          <li
            @click="asdSwitch(3)"
            :class="{'on':onClick==3}"
          >专业管理</li>
        </ul>
      </div>
      <div id="searchSection">
        <div class="search-line clearfix">
          <!-- 院系管理条件查找 -->
          <div v-if="onClick==2">
            <select
              class="s-select separate"
              v-model="queryAcademyInfo.province"
              @change="getSchool(queryAcademyInfo.province,1)"
              v-if="this.$store.state.userInfo.role != 3"
            >
              <option value="">所属省份</option>
              <option
                :value="key"
                v-for="(val, key) in provinceData"
                :key="key"
              >{{ val }}</option>
            </select>
            <select
              class="s-select separate"
              v-model="queryAcademyInfo.school_id"
              @change="getAcademy(queryAcademyInfo.school_id,1)"
              v-if="this.$store.state.userInfo.role != 3"
            >
              <option value="">所属学校</option>
              <option
                v-for="(item, index) in searchSchoolData"
                :key="index"
                :value="item.id"
              >
                {{ item.title }}
              </option>
            </select>
            <select
              class="s-select separate"
              v-model="queryAcademyInfo.status"
            >
              <option value="">学院状态</option>
              <option value="0">禁用</option>
              <option value="1">启用</option>
            </select>
            <input
              type="text"
              placeholder="学院名称"
              class="s-input separate"
              :disabled="parseInt(localUser.role)===1 && onClick ===1"
              v-model="queryAcademyInfo.title"
            >
            <input
              type="button"
              value="搜索"
              class="s-btn"
              @click="pageAcademyCallback(1)"
            >
          </div>
          <!-- 专业管理条件查找 -->
          <div v-if="onClick==3">
            <select
              class="s-select separate"
              v-model="queryMajorInfo.province"
              @change="getSchool(queryMajorInfo.province,1)"
              v-if="this.$store.state.userInfo.role != 3"
            >
              <option value="">所属省份</option>
              <option
                :value="key"
                v-for="(val, key) in provinceData"
                :key="key"
              >{{ val }}</option>
            </select>
            <select
              class="s-select separate"
              v-model="queryMajorInfo.school_id"
              @change="getAcademy(queryMajorInfo.school_id,1)"
              v-if="this.$store.state.userInfo.role != 3"
            >
              <option value="">所属学校</option>
              <option
                v-for="(item, index) in searchSchoolData"
                :key="index"
                :value="item.id"
              >
                {{ item.title }}
              </option>
            </select>
            <select
              class="s-select separate"
              v-model="queryMajorInfo.academy_id"
            >
              <option value="">所属学院</option>
              <option
                v-for="item in searchAcademyData"
                :key="item.id"
                :value="item.id"
              >
                {{ item.title }}
              </option>
            </select>
            <select
              class="s-select separate"
              v-model="queryMajorInfo.status"
            >
              <option value="">专业状态</option>
              <option value="0">禁用</option>
              <option value="1">启用</option>
            </select>
            <input
              type="text"
              placeholder="专业名称"
              class="s-input separate"
              :disabled="parseInt(localUser.role)===1 && onClick ===1"
              v-model="queryMajorInfo.title"
            >
            <input
              type="button"
              value="搜索"
              class="s-btn"
              @click="pageMajorCallback(1)"
            >
          </div>
          <div
            class="add-btn"
            v-if="parseInt(localUser.role)!=1 || onClick==2"
            style="margin-bottom:0;"
            @click="showAddWindow(onClick,'add')"
          >新建</div>
          <!-- <div
            class="import-btn"
            v-if="parseInt(localUser.role)!=1 || onClick==2"
            id="batchUpload"
            @click="showUploadWindow"
          >导入</div> -->
        </div>
      </div>

      <!-- 学院列表 -->
      <div
        id="list"
        v-if="onClick==2"
      >
        <table>
          <tbody>
            <tr class="l_header">
              <th class="itemStatus">学院编号</th>
              <th class="itemStatus">学院名称</th>
              <th class="itemStatus">专业数量</th>
              <th class="itemStatus">所属学校</th>
              <th class="itemStatus">所属省份</th>
              <th class="itemStatus">状态</th>
              <th
                class="action"
                width="180"
              >操作</th>
            </tr>
            <tr
              class="item"
              v-for="item in academyTableData"
              :key="item.id"
            >
              <td class="itemStatus">{{item.code}}</td>
              <td class="itemStatus">{{item.title}}</td>
              <td class="itemStatus">{{item.major_count}}</td>
              <td class="itemStatus">{{item.school.title}}</td>
              <td class="itemStatus">{{formatProvince(item.school.province)}}</td>
              <td :class="'itemStatus itemStatus' + item.status">{{ item.status == 1 ? '已启用' : '禁用' }}</td>
              <td class="action">
                <a
                  class="edit"
                  href="javascript:;"
                  @click="queryAcademySingle(item.id)"
                >编辑</a>
                <a
                  v-if="item.status==1"
                  class="nopublish"
                  href="javascript:;"
                  @click="unpublish(item,onClick)"
                >禁用</a>
                <a
                  v-if="item.status==0"
                  class="publish"
                  href="javascript:;"
                  @click="publish(item,onClick)"
                >启用</a>
                <a
                  class="delete"
                  href="javascript:;"
                  @click="askNoDelete"
                  v-if="item.major_count>0"
                >删除</a>
                <a
                  class="delete"
                  href="javascript:;"
                  @click="askDelete(item)"
                  v-else
                >删除</a>
              </td>
            </tr>
          </tbody>
          <tr
            class="noitems"
            v-if="!academyTableData.length"
          >
            <td colspan="7">没有数据</td>
          </tr>
        </table>
        <!-- 分页 -->
        <pagination
          :cur='pageAcademyInfo.page'
          :all='pageAcademyInfo.all'
          :totalData="pageAcademyInfo.totalData"
          :callback="pageAcademyCallback"
        ></pagination>
      </div>
      <!-- 专业列表 -->
      <div
        id="list"
        v-if="onClick==3"
      >
        <table>
          <tbody>
            <tr class="l_header">
              <th class="itemStatus">专业编号</th>
              <th class="itemStatus">专业名称</th>
              <th class="itemStatus">所属学院</th>
              <th class="itemStatus">所属学校</th>
              <th class="itemStatus">所属省份</th>
              <th class="itemStatus">状态</th>
              <th
                class="action"
                width="180"
              >操作</th>
            </tr>
            <tr
              class="item"
              v-for="item in majorTableData"
              :key="item.id"
            >
              <td class="itemStatus">{{item.code}}</td>
              <td class="itemStatus">{{item.title}}</td>
              <td class="itemStatus">{{item.academy.title}}</td>
              <td class="itemStatus">{{item.academy.school.title}}</td>
              <td class="itemStatus">{{formatProvince(item.academy.school.province)}}</td>
              <td :class="'itemStatus itemStatus' + item.status">{{ item.status == 1 ? '已启用' : '禁用' }}</td>
              <td class="action">
                <a
                  class="edit"
                  href="javascript:;"
                  @click="queryMajorSingle(item.id)"
                >编辑</a>
                <a
                  v-if="item.status==1"
                  class="nopublish"
                  href="javascript:;"
                  @click="unpublish(item,onClick)"
                >禁用</a>
                <a
                  v-if="item.status==0"
                  class="publish"
                  href="javascript:;"
                  @click="publish(item,onClick)"
                >启用</a>
                <a
                  class="delete"
                  href="javascript:;"
                  @click="askDle(item)"
                >删除</a>
              </td>
            </tr>
          </tbody>
          <tr
            class="noitems"
            v-if="!majorTableData.length"
          >
            <td colspan="7">没有数据</td>
          </tr>
        </table>

        <!-- 分页 -->
        <pagination
          :cur='pagemajorInfo.page'
          :all='pagemajorInfo.all'
          :totalData="pagemajorInfo.totalData"
          :callback="pageMajorCallback"
        ></pagination>
      </div>

      <!-- 专业添加/编辑弹窗 -->
      <div
        class="form_overlay"
        :style="classShowAddWindow"
      >
        <div class="form_overlay_bg"></div>

        <!-- 学院管理 -->
        <div
          class="form_panel"
          v-if="onClick==2"
        >
          <div class="form_title">学院管理</div>
          <div class="form_content">
            <form id="itemForm">
              <div class="item">
                <span class="label"><i class="require">*</i>学院编号:</span>
                <input
                  type="hidden"
                  v-model="academyInfo.id"
                >
                <input
                  type="text"
                  v-model="academyInfo.code"
                  maxlength="25"
                >
              </div>
              <div class="item">
                <span class="label"><i class="require">*</i>学院名称:</span>
                <input
                  type="text"
                  v-model="academyInfo.title"
                  maxlength="25"
                >
              </div>
              <div
                class="item"
                v-if="this.$store.state.userInfo.role != 3"
              >
                <span class="label"><i class="require">*</i>所属省份:</span>
                <select
                  :disabled="parseInt(this.localUser.role) === 1"
                  v-model="academyInfo.province"
                  @change="getSchool(academyInfo.province)"
                >
                  <option value="">选择省份</option>
                  <option
                    :value="key"
                    v-for="(val, key) in provinceData"
                    :key="key"
                  >{{ val }}</option>
                </select>
              </div>
              <div
                class="item"
                v-if="this.$store.state.userInfo.role != 3"
              >
                <span class="label"><i class="require">*</i>所属学校:</span>
                <select
                  :disabled="parseInt(this.localUser.role) === 1"
                  v-model="academyInfo.school_id"
                >
                  <option value="">选择学校</option>
                  <option
                    v-for="(item, index) in schoolData"
                    :key="index"
                    :value="item.id"
                  >
                    {{ item.title }}
                  </option>
                </select>
              </div>
            </form>
          </div>
          <div class="form_control">
            <a
              href="javascript:;"
              class="button close"
              id="form_close"
              @click="hideAddWindow"
            >取消</a>
            <a
              href="javascript:;"
              class="button"
              id="form_submit"
              @click="saveAcademynfo"
            >提交</a>
          </div>
        </div>
        <!-- 专业管理 -->
        <div
          class="form_panel"
          v-if="onClick==3"
        >
          <div class="form_title">专业管理</div>
          <div class="form_content">
            <form id="itemForm">
              <div class="item">
                <span class="label"><i class="require">*</i>专业编号:</span>
                <input
                  type="text"
                  v-model="majorInfo.code"
                  maxlength="25"
                >
              </div>
              <div class="item">
                <span class="label"><i class="require">*</i>专业名称:</span>
                <input
                  type="text"
                  v-model="majorInfo.title"
                  maxlength="25"
                >
              </div>
              <div
                class="item"
                v-if="this.$store.state.userInfo.role != 3"
              >
                <span class="label"><i class="require">*</i>所属省份:</span>
                <select
                  :disabled="parseInt(this.localUser.role) === 1"
                  v-model="majorInfo.province"
                  @change="getSchool(majorInfo.province)"
                >
                  <option value="">选择省份</option>
                  <option
                    :value="key"
                    v-for="(val, key) in provinceData"
                    :key="key"
                  >{{ val }}</option>
                </select>
              </div>
              <div
                class="item"
                v-if="this.$store.state.userInfo.role != 3"
              >
                <span class="label"><i class="require">*</i>所属学校:</span>
                <select
                  :disabled="parseInt(this.localUser.role) === 1"
                  v-model="majorInfo.school_id"
                  @change="getAcademy(majorInfo.school_id)"
                >
                  <option value="">选择学校</option>
                  <option
                    v-for="(item, index) in schoolData"
                    :key="index"
                    :value="item.id"
                  >
                    {{ item.title }}
                  </option>
                </select>
              </div>
              <div class="item">
                <span class="label"><i class="require">*</i>所属学院:</span>
                <select
                  :disabled="parseInt(this.localUser.role) === 1"
                  v-model="majorInfo.academy_id"
                >
                  <option value="">选择学院</option>
                  <option
                    v-for="item in academyData"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.title }}
                  </option>
                </select>
              </div>
            </form>
          </div>
          <div class="form_control">
            <a
              href="javascript:;"
              class="button close"
              id="form_close"
              @click="hideAddWindow"
            >取消</a>
            <a
              href="javascript:;"
              class="button"
              id="form_submit"
              @click="saveMajorInfo"
            >提交</a>
          </div>
        </div>
      </div>
      <div
        class="form_overlay"
        :style="classShowUploadWindow"
      >
        <div class="form_overlay_bg"></div>
        <div class="form_panel">
          <div class="form_title">批量上传</div>
          <div class="form_content">
            <form id="uploadForm">
              <div class="item">
                <span
                  class="label"
                  style="width: auto"
                ><i class="require"></i>模版创建规则:</span>
                <div class="item-box divLabel gray">
                  <div class="normal-width">
                    <p>1. 文件格式为常用的Excel文件（.xls）；</p>
                    <p>2. 填写导入数据时，需先删除导入模版中首行以下所有说明示例数据，且第二行中文说明字段前带*号的为必填项；</p>
                    <p>3. 导入文件中如存在多个sheet工作表，表头应与示例工作表表头完全一致；</p>
                    <p>4. 导入的数据总条数不得超过2000条，如超过，则需分多次导入；</p>
                    <p>5. 注意：请保证“专业”所属“父级编号”的学院信息位置在前。</p>
                  </div>
                </div>
                <div class="clear"></div>
                <div class="attachment">
                  <a
                    href="/static/upload_template/batch_upload_academy_template.xls"
                    download="batch_upload_academy_template.xls"
                    target="_blank"
                  >模版下载</a>
                </div>
              </div>
              <div class="item">
                <span
                  class="label"
                  style="width: auto"
                ><i class="require">*</i>xls文件:</span>
                <div
                  class="item-box"
                  style="margin-left: 130px;"
                >
                  <input
                    v-model="uploadedCsv"
                    disabled
                    type="text"
                    id="fileUrl"
                    style="width: 225px;"
                  >
                  <span
                    class="button"
                    style="position: relative;top: 0px; left: 0px;"
                  >
                    选择文件
                    <input
                      @change="xlsChange"
                      type="file"
                      accept=".csv,.xls,.xlsx"
                      ref="xlsFile"
                      id="fileUpload"
                      class="upload-derict"
                    >
                  </span>
                </div>
                <div class="clear"></div>
              </div>
            </form>
          </div>
          <div class="form_control">
            <a
              href="javascript:;"
              style="width: 30px"
              class="button close"
              id="form_upload_close"
              @click="hideUploadWindow"
            >取消</a>
            <a
              href="javascript:;"
              style="width: 30px"
              class="button"
              id="form_upload_submit"
              @click="submitCsv"
            >提交</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../../../components/Pager'
export default {
  name: 'Academy',
  components: {
    Pagination
  },
  data() {
    return {
      onClick: 2,
      classShowAddWindow: {},
      classShowUploadWindow: {},
      tableData: [],
      academyTableData: [],
      majorTableData: [],
      schoolData: [],
      searchSchoolData: [],
      academyData: [],
      searchAcademyData: [],
      academyTableDataCount: 0, // 学院列表总数据
      majorTableDataCount: 0, // 专业列表总数据
      queryAcademyInfo: {
        page: 1,
        size: 10,
        status: '',
        title: '',
        province: '',
        school_id: ''
      },
      queryMajorInfo: {
        page: 1,
        size: 10,
        status: '',
        title: '',
        province: '',
        school_id: '',
        academy_id: ''
      },

      uploadedCsv: '',
      academyInfo: { // 学院表单数据
        id: 0,
        code: '',
        status: '1',
        title: '',
        school_id: '',
        province: ''
      },
      majorInfo: { // 专业表单数据
        id: 0,
        code: '',
        title: '',
        status: '1',
        province: '',
        academy_id: '',
        school_id: ''
      }
    }
  },
  methods: {
    formatProvince(value) {
      return this.$store.state.dict_province[value]
    },
    async xlsChange() {
      const uploadUrl = '/files/' + this.$refs.xlsFile.files[0].name
      await this.$http.put(uploadUrl, this.$refs.xlsFile.files[0]).then((data) => {
        this.uploadedCsv = data
      }).catch(() => {
        this.$parent.showMsg('上传失败！')
      })
    },
    asdSwitch(e) {
      this.onClick = e
      if (e === 3) {
        this.queryMajorInfo = {
          page: 1,
          size: 10,
          status: '',
          title: '',
          province: '',
          school_id: '',
          academy_id: ''
        }
        this.searchMajor()
      } else {
        this.queryAcademyInfo = {
          page: 1,
          size: 10,
          status: '',
          title: '',
          province: '',
          school_id: ''
        }
        this.searchAcademy()
      }
    },

    // 打开专业添加/编辑弹窗
    showAddWindow(click, value) {
      if (click === 2 && value === 'add') {
        this.academyInfo = { // 学院表单数据
          id: 0,
          code: '',
          status: '1',
          title: '',
          province: '',
          school_id: ''
        }
        if (parseInt(this.localUser.role) === 3) {
          this.academyInfo.school_id = this.$store.state.userInfo.school_id
          this.getAcademy(this.academyInfo.school_id)
        }
      } else if (click === 3 && value === 'add') {
        this.majorInfo = { // 专业表单数据
          id: 0,
          code: '',
          title: '',
          status: '1',
          province: '',
          academy_id: '',
          school_id: ''
        }
        if (parseInt(this.localUser.role) === 3) {
          this.majorInfo.school_id = this.$store.state.userInfo.school_id
          this.getAcademy(this.majorInfo.school_id)
        }
      }
      this.classShowAddWindow = {
        visibility: 'visible'
      }
    },
    // 关闭专业添加/编辑弹窗
    hideAddWindow() {
      this.classShowAddWindow = {}
      this.academyData = []
      this.schoolData = []
    },
    // 打开上传弹窗
    showUploadWindow() {
      this.classShowUploadWindow = {
        visibility: 'visible'
      }
    },
    // 关闭上传弹窗
    hideUploadWindow() {
      this.classShowUploadWindow = {}
    },
    // 禁用
    unpublish(item, click) {
      this.$parent.showConfirm('确定要禁用该记录吗？', () => {
        this.askDisable(item, 0, click)
      })
    },
    // 启用
    publish(item, click) {
      this.$parent.showConfirm('确定要启用该记录吗？', () => {
        this.askDisable(item, 1, click)
      })
    },
    // 禁用
    async askDisable(item, status, click) {
      const msg = status === 0 ? '禁用' : '启用'
      var params
      if (click === 2) {
        params = {
          code: item.code,
          title: item.title,
          status: status
        }
      } else {
        params = {
          code: item.code,
          title: item.title,
          status: status,
          academy_id: item.academy_id
        }
      }

      const url = click === 2 ? '/academy/' + item.id + '/' : '/major/' + item.id + '/'
      await this.$http.put(url, params).then((data) => {
        this.$parent.showMsg(msg + '成功！')
        if (click === 2) {
          this.searchAcademy()
        } else if (click === 3) {
          this.searchMajor()
        }
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg(msg + '失败！')
      })
    },

    // 获取院系数据
    async searchAcademy() {
      if (parseInt(this.localUser.role) === 3) {
        this.queryAcademyInfo.school_id = this.$store.state.userInfo.school_id
      }
      await this.$http.get('/academy/', {
        params: this.queryAcademyInfo
      }).then((data) => {
        this.academyTableData = data.results
        this.academyTableDataCount = data.count
      }).catch((error) => {
        console.log(error)
      })
    },
    // 获取所有学院数据
    async getSchool(value, category) {
      const params = {
        page: 1,
        size: 10000,
        province: value,
        status: 1
      }
      if (value) {
        await this.$http.get('/school/', { params }).then((data) => {
          if (category) {
            this.searchSchoolData = data.results
            this.searchAcademyData = []
            this.queryAcademyInfo.school_id = ''
            this.queryMajorInfo.school_id = ''
            this.queryMajorInfo.academy_id = ''
          } else {
            this.schoolData = data.results
            this.academyData = []
            this.academyInfo.school_id = ''
            this.majorInfo.school_id = ''
            this.majorInfo.academy_id = ''
          }
        }).catch((error) => {
          console.log(error)
        })
      } else {
        this.searchSchoolData = []
        this.schoolData = []
        this.searchAcademyData = []
        this.academyData = []
        this.queryAcademyInfo.school_id = ''
        this.queryMajorInfo.school_id = ''
        this.academyInfo.school_id = ''
        this.queryMajorInfo.academy_id = ''
        this.majorInfo.school_id = ''
        this.majorInfo.academy_id = ''
      }
    },
    // 获取所有院系
    async getAcademy(value, category) {
      const params = {
        page: 1,
        size: 10000,
        school_id: value,
        status: 1
      }
      if (value) {
        await this.$http.get('/academy/', { params }).then((data) => {
          if (category) {
            this.searchAcademyData = data.results
          } else {
            this.academyData = data.results
            this.majorInfo.academy_id = ''
          }
        }).catch((error) => {
          console.log(error)
        })
      } else {
        this.searchAcademyData = []
        this.academyData = []
        this.queryMajorInfo.academy_id = ''
        this.majorInfo.academy_id = ''
      }
    },
    // 获取院系下面所有的专业
    // async getQueryMajor(value) {
    //   const params = {
    //     academy_id: value,
    //     page: 1,
    //     size: 10000
    //   }
    //   if (value) {
    //     await this.$http.get('/major/', { params }).then((data) => {
    //       this.querymajorData = data.results
    //     }).catch((error) => {
    //       this.$parent.showMsg('该院系下暂未设置专业')
    //       console.log(error)
    //     })
    //   } else {
    //     this.querymajorData = []
    //     this.queryMajorInfo.major = ''
    //   }
    // },
    async searchMajor() {
      if (parseInt(this.localUser.role) === 1) {
        this.queryMajorInfo.academy_id = this.localUser.academy_id
      }
      if (parseInt(this.localUser.role) === 3) {
        this.queryMajorInfo.school_id = this.$store.state.userInfo.school_id
        await this.getAcademy(this.queryMajorInfo.school_id, 1)
      }
      await this.$http.get('/major/', {
        params: this.queryMajorInfo
      }).then((data) => {
        this.majorTableData = data.results
        this.majorTableDataCount = data.count
      }).catch((error) => {
        console.log(error)
      })
    },

    // 新增/编辑学院
    async saveAcademynfo() {
      if (!this.academyInfo.code) {
        this.$parent.showMsg('请输入学院编号!')
        return false
      }
      if (!this.academyInfo.title) {
        this.$parent.showMsg('请输入学院名称!')
        return false
      }
      if (!this.academyInfo.province && parseInt(this.localUser.role) !== 3) {
        this.$parent.showMsg('请选择省份!')
        return false
      }
      if (!this.academyInfo.school_id && parseInt(this.localUser.role) !== 3) {
        this.$parent.showMsg('请选择学校!')
        return false
      }
      if (parseInt(this.localUser.role) === 3) {
        this.academyInfo.school_id = this.$store.state.userInfo.school_id
      }
      const checkTitleData = await this.$http.get('/academy/', {
        params: {
          school_id: this.academyInfo.school_id,
          eq_title: this.academyInfo.title
        }
      })
      const checkCodeData = await this.$http.get('/academy/', {
        params: {
          school_id: this.academyInfo.school_id,
          eq_code: this.academyInfo.code
        }
      })
      if (this.academyInfo.id) {
        if (checkCodeData.results.length > 0) {
          for (let i = 0; i < checkCodeData.results.length; i++) {
            if (checkCodeData.results[i].id !== this.academyInfo.id) {
              this.$layer.msg('学院编号已存在!')
              return false
            }
          }
        }
        if (checkTitleData.results.length > 0) {
          for (let i = 0; i < checkTitleData.results.length; i++) {
            if (checkTitleData.results[i].id !== this.academyInfo.id) {
              this.$layer.msg('学院名称已存在!')
              return false
            }
          }
        }
        const url = '/academy/' + this.academyInfo.id + '/'
        await this.$http.put(url, this.academyInfo).then((data) => {
          if (data.id) {
            this.$parent.showMsg('修改成功！')
            this.hideAddWindow()
            this.searchAcademy()
          } else {
            this.$parent.$parent.showMsg('修改失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('修改失败！')
        })
      } else {
        if (checkCodeData.results.length > 0) {
          this.$layer.msg('学院编号已存在!')
          return false
        }
        if (checkTitleData.results.length > 0) {
          this.$layer.msg('学院名称已存在!')
          return false
        }
        this.academyInfo.status = 1
        await this.$http.post('/academy/', this.academyInfo).then((data) => {
          if (data.id) {
            this.$parent.showMsg('添加成功！')
            this.hideAddWindow()
            this.searchAcademy()
          } else {
            this.$parent.showMsg('添加失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('添加失败！')
        })
      }
    },
    // 新增/编辑专业
    async saveMajorInfo() {
      if (!this.majorInfo.code) {
        this.$parent.showMsg('请输入专业编号!')
        return false
      }
      if (!this.majorInfo.title) {
        this.$parent.showMsg('请输入专业名称!')
        return false
      }
      if (!this.majorInfo.province && parseInt(this.localUser.role) !== 3) {
        this.$parent.showMsg('请选择省份!')
        return false
      }
      if (!this.majorInfo.school_id && parseInt(this.localUser.role) !== 3) {
        this.$parent.showMsg('请选择学校!')
        return false
      }
      if (!this.majorInfo.academy_id) {
        this.$parent.showMsg('请选择学院!')
        return false
      }
      const checkTitleData = await this.$http.get('/major/', {
        params: {
          academy_id: this.majorInfo.academy_id,
          eq_title: this.majorInfo.title
        }
      })
      const checkCodeData = await this.$http.get('/major/', {
        params: {
          academy_id: this.majorInfo.academy_id,
          eq_code: this.majorInfo.code
        }
      })
      if (this.majorInfo.id) {
        if (checkCodeData.results.length > 0) {
          for (let i = 0; i < checkCodeData.results.length; i++) {
            if (checkCodeData.results[i].id !== this.majorInfo.id) {
              this.$layer.msg('专业编号已存在!')
              return false
            }
          }
        }
        if (checkTitleData.results.length > 0) {
          for (let i = 0; i < checkTitleData.results.length; i++) {
            if (checkTitleData.results[i].id !== this.majorInfo.id) {
              this.$layer.msg('专业名称已存在!')
              return false
            }
          }
        }
        const url = '/major/' + this.majorInfo.id + '/'
        await this.$http.put(url, this.majorInfo).then((data) => {
          if (data.id) {
            this.$parent.showMsg('修改成功！')
            this.hideAddWindow()
            this.searchMajor()
          } else {
            this.$parent.$parent.showMsg('修改失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('修改失败！')
        })
      } else {
        if (checkCodeData.results.length > 0) {
          this.$layer.msg('专业编号已存在!')
          return false
        }
        if (checkTitleData.results.length > 0) {
          this.$layer.msg('专业名称已存在!')
          return false
        }
        await this.$http.post('/major/', {
          code: this.majorInfo.code,
          title: this.majorInfo.title,
          academy_id: this.majorInfo.academy_id,
          status: 1
        }).then((data) => {
          if (data.id) {
            this.$parent.showMsg('添加成功！')
            this.hideAddWindow()
            this.searchMajor()
          } else {
            this.$parent.showMsg('添加失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('添加失败！')
        })
      }
    },

    // 编辑时查询学院数据
    async queryAcademySingle(id) {
      const url = '/academy/' + id + '/'
      await this.$http.get(url).then(async (data) => {
        this.academyInfo.id = id
        this.academyInfo.code = data.code
        this.academyInfo.title = data.title
        this.academyInfo.province = data.school.province
        await this.getSchool(this.academyInfo.province)
        this.academyInfo.school_id = data.school_id
        await this.getAcademy(this.academyInfo.school_id)
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg('数据获取失败！')
      })
      this.classShowAddWindow = {
        visibility: 'visible'
      }
    },
    // 编辑时查询专业数据
    async queryMajorSingle(id) {
      const url = '/major/' + id + '/'
      await this.$http.get(url).then(async (data) => {
        this.majorInfo.id = id
        this.majorInfo.code = data.code
        this.majorInfo.title = data.title
        this.majorInfo.province = data.academy.school.province
        await this.getSchool(this.majorInfo.province)
        this.majorInfo.school_id = data.academy.school_id
        await this.getAcademy(this.majorInfo.school_id)
        this.majorInfo.academy_id = data.academy_id
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg('数据获取失败！')
      })
      this.classShowAddWindow = {
        visibility: 'visible'
      }
    },

    askNoDelete() {
      this.$parent.showMsg('该学院下面有专业,暂时无法删除！')
    },
    // 删除学院
    async askDelete(item) {
      const url = '/academy/' + item.id + '/'
      await this.$parent.showConfirm('确认删除此条数据吗?', () => {
        this.$http.put(url, {
          code: item.code,
          title: item.title,
          isdel: 1
        }).then((data) => {
          this.$parent.showMsg('删除成功！')
          this.searchAcademy()
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('删除失败！')
        })
      })
    },
    // 删除专业
    async askDle(item) {
      const url = '/major/' + item.id + '/'
      await this.$parent.showConfirm('确认删除此条数据吗?', () => {
        this.$http.put(url, {
          isdel: 1,
          code: item.code,
          title: item.title,
          academy_id: item.academy_id
        }).then((data) => {
          this.$parent.showMsg('删除成功！')
          this.searchMajor()
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('删除失败！')
        })
      })
    },
    async submitCsv() {
      const uploadUrl = '/get_excel/'
      await this.$http.get(uploadUrl, {
        params: {
          file_name: this.uploadedCsv
        }
      }).then((data) => {
        if (data.length <= 2) {
          this.$parent.showMsg('表格中无数据！')
          return
        }

        data.splice(0, 2)

        this.uploadedCscData = data

        this.hideUploadWindow()

        this.classShowProcessWindow = {
          visibility: 'visible'
        }
        this.isFinishUpsert = false
        this.curCsvIndex = 0
        this.csvFinishText = ''
        this.errorList = []
        this.insertOne()
      }).catch(() => {
        this.$parent.showMsg('读取失败！')
      })
    },
    async insertOne() {
      if (this.curCsvIndex >= this.uploadedCscData.length) {
        this.csvFinishText = '上传完成'
        this.isFinishUpsert = true
        this.onClick === 2 ? this.searchAcademy() : this.searchMajor()
        return
      }

      const row = this.uploadedCscData[this.curCsvIndex]
      // const studentIds = this.tableData.map(item => item.code)
      // region 数据检查开始

      if (row[0].trim().length === 0) {
        this.errorList.push({ code: 0, text: '[' + row[0] + ']' + '请输入编号！' })
        this.curCsvIndex++
        await this.insertOne()
        return
      }

      if (row[1].trim().length === 0) {
        this.errorList.push({ code: 0, text: '[' + row[0] + ']' + '请输入名称！' })
        this.curCsvIndex++
        await this.insertOne()
        return
      }
      if (row[2].trim().length === 0 && this.onClick === 3) {
        this.errorList.push({ code: 0, text: '[' + row[2] + ']' + '请输入学院编号！' })
        this.curCsvIndex++
        await this.insertOne()
        return
      }
      if (row[2].trim().length > 0 && this.onClick === 2) {
        this.curCsvIndex++
        await this.insertOne()
      }
      var obj = this.$store.state.dict_province
      var provinceKey = ''

      Object.keys(obj).forEach(function(key) {
        if (obj[key] === row[4]) {
          provinceKey = key
        }
      })
      if (provinceKey === '0') {
        this.$parent.showMsg('省份错误，请参照模板给出的省份进行添加！')
        this.curCsvIndex++
        await this.insertOne()
        return
      }
      await this.getAllSchool(row[3])

      // const url = this.onClick === 2 ? '/academy/' : '/major/'
      // var addForm
      // if (this.onClick === 2) {
      //   addForm = {
      //     code: row[0],
      //     title: row[1]
      //   }
      // } else {
      //   if (studentIds.indexOf(row[2]) < 0) {
      //     this.$parent.showMsg('您填写的学院编码所在数据没被启用或未被创建,无法导入！')
      //     return
      //   } else {
      //     addForm = {
      //       code: row[0],
      //       title: row[1],
      //       academy_id: parseInt(this.localUser.role) === 2 ? this.localUser.academy_id : this.tableData[studentIds.indexOf(row[2])].id
      //     }
      //   }
      // }
      // await this.$http.post(url, addForm).then(async (data) => {
      //   this.errorList.push({ code: 1, text: '[' + addForm.title + ']' + '导入成功！' })
      //   this.curCsvIndex++
      //   this.insertOne()
      // }).catch((error) => {
      //   console.dir(error)
      //   this.errorList.push({ code: 0, text: '[' + addForm.title + ']' + error.response.data[0] })
      //   this.curCsvIndex++
      //   this.insertOne()
      // })
    },

    // 学院分页
    pageAcademyCallback(data) {
      this.queryAcademyInfo.page = data
      this.searchAcademy()
    },
    // 专业分页
    pageMajorCallback(data) {
      this.queryMajorInfo.page = data
      this.searchMajor()
    },
    async getAllSchool(val) {
      const params = {
        page: 1,
        size: 10000,
        title: val
      }
      await this.$http.get('/school/', { params }).then((data) => {
        this.schoolTableData = data.results
        this.schoolTableDataCount = data.count
      }).catch((error) => {
        console.log(error)
      })
    }

  },
  // 计算属性
  computed: {

    // 学院分页查询
    pageAcademyInfo() {
      return {
        page: this.queryAcademyInfo.page,
        all: Math.ceil(this.academyTableDataCount / this.queryAcademyInfo.size),
        totalData: this.academyTableDataCount
      }
    },
    // 专业分页查询
    pagemajorInfo() {
      return {
        page: this.queryMajorInfo.page,
        all: Math.ceil(this.majorTableDataCount / this.queryMajorInfo.size),
        totalData: this.majorTableDataCount
      }
    },
    localUser() {
      return this.$store.state.userInfo
    },
    provinceData() {
      return this.$store.state.dict_province
    }
  },
  mounted() {
    this.searchAcademy()
  }
}
</script>

<style scoped>
.tab-wrap ul li.on,
.tab-wrap ul li:hover {
  border-bottom: 2px solid #73D6CA;
  color: #73D6CA;
}
</style>
